import React from 'react'
import PropTypes from 'prop-types'
import { buildFirebaseUrl } from 'commons/js/util/firebaseUrlBuilder'
import UrlTo from 'commons/js/util/UrlTo'

const AppDownloadButton = ({ height, imageUri, alt, campaign, content, webUrl, dataTest }) => {
    const utmParams = [
        { key: 'utm_source', value: 'elparking' },
        { key: 'utm_medium', value: 'web' },
        { key: 'utm_campaign', value: campaign },
        { key: 'utm_content', value: content },
    ]

    const firebaseBaseUrl = buildFirebaseUrl('https://elparking.com', webUrl)
    const firebaseUrlWithParameters = UrlTo.appendUrlParams(firebaseBaseUrl, utmParams)
    return (
        <a data-test={dataTest} rel='noopener noreferrer' target='_blank' href={firebaseUrlWithParameters}>
            <img height={height} src={imageUri} alt={alt} />
        </a>
    )
}

AppDownloadButton.defaultProps = {
    height: '40px',
    content: window.location.pathname,
}

AppDownloadButton.propTypes = {
    height: PropTypes.string,
    imageUri: PropTypes.string.isRequired,
    alt: PropTypes.string,
    campaign: PropTypes.string,
    content: PropTypes.string,
    webUrl: PropTypes.string,
    dataTest: PropTypes.string,
}

export default AppDownloadButton
